import SubText from "components/shared/SubText";
import SongList from "pages/musicPage/shared/SongList";
import React, { useState, useEffect } from "react";
import SongListHome from "./SongListHome";
import MostPlayedSongSkeleton from "components/skeleton/MostPlayedSongSkeleton";
import MusicTableTow from "pages/musicPage/shared/MusicTableTow";

function CreatorHomeTracksGrid({
  userPlaylists,
  setUserPlaylists,
  favorite,
  songs,
  removeFromPlaylist,
  setRemovedSongId,
  handleShowMore,
  user,
  playlistId,
}: any) {
  return (
    <>
      {songs && (
        <>
          <div className="mt-10 ml-3 flex w-[90%] items-center justify-between max-sm:ml-0 max-sm:w-full">
            <SubText text="Tracks" className="font-bold" />
            {songs?.length > 3 && (
              <p
                className="group flex cursor-pointer items-center gap-1 text-[14px] font-[500] text-[#F50537] transition-all duration-200 hover:gap-2"
                onClick={handleShowMore}
              >
                Show more
                <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                  →
                </span>
              </p>
            )}
          </div>
          <div className="mt-5 ml-3 w-[90%] text-white max-sm:ml-0 max-sm:w-full max-sm:overflow-x-hidden">
            <div className="w-full text-white max-sm:overflow-x-hidden">
              <table className="w-full">
                <thead>
                  <tr className="cursor-default border-b border-white/10 text-left text-[11px] uppercase tracking-wider text-[#7B9DB4]">
                    <th className="w-[5%] pb-3 pl-3 font-medium max-sm:pl-0">
                      #
                    </th>
                    <th className="w-[35%] pb-3 font-medium max-sm:pl-5">
                      Track
                    </th>
                    <th className="w-[25%] pb-3 font-medium">Artist</th>
                    <th className="w-[25%] pb-3 font-medium max-sm:ml-[10px]">
                      Duration
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* spacer row */}
                  <tr>
                    <td colSpan={5} className="h-3" />
                  </tr>
                  {songs?.slice(0, 3)?.map((data: any, i: number) => (
                    <MusicTableTow
                      id={i + 1}
                      data={data}
                      user={user}
                      key={i}
                      userPlaylists={userPlaylists}
                      setUserPlaylists={setUserPlaylists}
                      favorite={favorite}
                      removeFromPlaylist={removeFromPlaylist}
                      setRemovedSongId={setRemovedSongId}
                      playlistId={playlistId}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default CreatorHomeTracksGrid;